import settings from "@/settings";
import router from "@/router";
import {slugify} from "@/helpers/slugify";

export default {
  bookmarksByCompanySections: (state, getters) => {
    let bookmarks = {}
    let sectionsCompanySettings = getters.sections.filter((item) => {
          return settings.CURRENT_ENABLED_SECTIONS_TO_BOOKMARK.includes(item.code)
        }).map(item => item.idSettingCompany)
    getters.bookmarks.forEach(item => {
      let section = null;
      if (sectionsCompanySettings.includes(item._embedded.Content.idType)) {
        section = getters.sections.find(elem => {
          return item._embedded.Content.idType === elem.idSettingCompany
        })
      }
      // eslint-disable-next-line no-prototype-builtins
      if(item._embedded.hasOwnProperty('Solution') && getters.customCompanyContentCategories([item._embedded.Solution.idCategory]).length) {
        section = getters.customCompanyContentCategories([item._embedded.Solution.idCategory])[0]
      }
      if(section) {
        if(bookmarks[section.idSettingCompany]) {
          return bookmarks[section.idSettingCompany].bookmarks.push(item);
        }
        bookmarks[section.idSettingCompany] = {
          id: section.idSettingCompany,
          name: section.value,
          slug: slugify(section.value),
          code: settings.CURRENT_ENABLED_SECTIONS.includes(section.code) ? section.code : section.settingTypeCode,
          order: settings.CURRENT_ENABLED_SECTIONS.includes(section.code) ? section.order : section.order + 100,
          section: section,
          bookmarks: [
            item
          ]
        }
      }
    })
    return Object.values(bookmarks).sort((a,b) => {
      return a.order - b.order
    })
  },
  bookmarkByContentID: (state, getters) => (id) => {
    return  getters.bookmarks.find(item => {
      return item.idContent === id
    })
  },
  notificationByCompany: (state, getters) => {
    return  getters.notifications.filter(item => {
      return item._embedded.Notification.idCompany === getters.selectedCompanyId
    }).sort((a, b) => {
      return b.createdAtTS - a.createdAtTS
    })
  },
  sectionByIdSettingCompany: (state, getters) => (id) => {
    return  getters.sections.find(item => {
      return item.idSettingCompany === id
    })
  },
  sectionByCode: (state, getters) => (code) => {
    return  getters.sections.find(item => {
      return item.code === code && item.idCompany === getters.company.idCompany
    })
  },
  sectionByCodeAndSlug: (state, getters) => (code, slug) => {
    return  getters.sections.find(item => {
      return item.code === code && item.idCompany === getters.company.idCompany && slugify(item.value) === slug
    })
  },
  settingsCompanyBySettingTypeCodeAndID: (state, getters) => (code, id) =>  {
    let settingCompany =  getters.settingsCompany.find(item => {
      return item.settingTypeCode === code && id === item.idSettingCompany
    })
    if(settingCompany !== undefined) return settingCompany;
    return {}
  },
  settingsCompanyByParentId: (state, getters) => (id) =>  {
    return  getters.settingsCompany.filter(item => {
      return id === item.idSettingCompanyParent
    })
  },
  settingsCompanyBySettingTypeCode: (state, getters) => (code) =>  {
    let categories =  getters.settingsCompany.filter(item => {
      return item.settingTypeCode === code && item.idCompany === getters.company.idCompany
    })
    return categories.sort((a,b) => {
      return a.order - b.order
    })
  },
  settingsCompanyByCode: (state, getters) => (code) =>  {
    let categories =  getters.settingsCompany.filter(item => {
      return item.code === code
    })
    return categories.sort((a,b) => {
      return a.order - b.order
    })
  },
  settingsCompanyFlagByCode: (state, getters) => (code) => {
    let setting = getters.settingsCompany.find((item => {
      return item.code === code
    }))
    return setting && setting.value === 'true'
  },
  settingsCompanyByID: (state, getters) => (id) => {
    let type = getters.settingsCompany.find(item => {
      return id === item.idSettingCompany
    })
    if(type !== undefined) return type;
    return {}
  },
  customCompanyContentCategories: (state, getters) => (values) => {
    let categories =  getters.settingsCompany.filter(item => {
      return values.includes(item.idSettingCompany)
    })
    return categories.sort((a,b) => {
      return a.order - b.order
    })
  },
  getContentFieldForProfile: (state, getters) => {
    return  getters.contentFields.filter(item => {
      return item.isVisibleInUserProfile === 1 && item.fieldType === 'CHOICE'
    })
  },
  getContentFieldById: (state, getters) => (id) => {
    return  getters.contentFields.find(item => {
      return item.idContentField === id
    })
  },
  getContentFieldOptionById: (state, getters) => (id) => {
    return  getters.contentFieldOptions.find(item => {
      return item.idContentFieldOption === id
    })
  },
  contentFieldsForIdeaBoard: (state, getters) => {
    let ideaBoardType = getters.sectionByCode(settings.MODULES.IDEA_BOARD)
    let fields =  getters.contentFields.filter(item => {
      return item.idSettingCompany === ideaBoardType.idSettingCompany
    })
    return fields.sort((a,b) => {
      return a.order - b.order
    })
  },
  contentFieldOptionsForIdeaBoard: (state, getters) => (id) => {
    let fields = getters.contentFieldOptions.filter(item => {
      return item.idContentField === id
    })

    return fields.sort((a,b) => {
      return a.order - b.order
    })
  },
  iconForSection: (state, getters) => (section) => {
    let icon  = getters.settingsCompany.find(item => {
      return item.settingTypeCode === settings.SETTING_TYPES.HOME_ICONS && section.idSettingCompany === item.valueDescription
    })
    if(!icon) {
      icon = getters.settingsCompany.find(item => {
        return item.settingTypeCode === settings.SETTING_TYPES.HOME_ICONS && (section.valueDescription === item.code)
      })
    }
    if(!icon) {
      icon = getters.settingsCompany.find(item => {
        return item.settingTypeCode === settings.SETTING_TYPES.HOME_ICONS && section.code === item.code
      })
    }
    if(!icon) {
      icon = getters.settingsCompany.find(item => {
        return item.settingTypeCode === settings.SETTING_TYPES.HOME_ICONS && item.code.includes(section.code)
      })
    }

    if(icon !== undefined) return icon;
    return {
      value: '/web/'+settings.HOME_ICONS[section.code],
      generic: true
    }
  },
  menu: (state, getters) => (mode = 'menu') => {
    let hideContactUsFromHomeScreen = getters.settingsCompanyFlagByCode(settings.SETTING_TYPES_FLAGS.HIDE_CONTACT_US_FROM_HOME)
    let sections = getters.sections.filter((item) => {
      if(mode === 'menu') {
        return settings.CURRENT_ENABLED_SECTIONS.includes(item.code) && (!item.intValue3 ||item.intValue3 === 2)
      }
      if(hideContactUsFromHomeScreen && item.code === settings.MODULES.CONTACT_US) {
        return false
      }
      return settings.CURRENT_ENABLED_SECTIONS.includes(item.code) && !item.intValue3
    })
    let menu = []
    let companySlug = getters.company.slug || slugify(getters.company.name)
    sections.forEach((item) => {
      let route = router.resolve({
        name: settings.ROUTER_MAPS[item.code],
        params: {companySlug: companySlug, slug: slugify(item.value)}
      });
      let code = item.code
      // if(getters.isMACSverseUser) {
      //   route = router.resolve({
      //     name: settings.ROUTER_MAPS.MACSVERSE,
      //     params: {slug: slugify(item.value)}
      //   });
      //   code = 'MACSVERSE'
      // }
      let icon = getters.iconForSection(item);
      menu.push({
        name: item.value,
        icon: icon?.value,
        genericIcon: icon?.generic,
        routeName: settings.ROUTER_MAPS[code],
        link: settings.ROUTER_MAPS[code] ? route.route.fullPath : item.value2,
        webContent: !settings.ROUTER_MAPS[code],
        readPendingItems: item.readPending ? item.readPending : 0,
      })
    })
    return menu;
  },
  countries: (state, getters) => {
    let countries =  getters.settingsGlobal.filter(item => {
      return item.idType === settings.COUNTRY_ID_TYPE
    })
    return countries.sort((a,b) => {
      return a.order - b.order
    })
  },
  //gdn
  gdnCountries: (state, getters) => (idSettingCompany) => {
    return getters.settingsCompany.filter((item) => {
      return item.settingTypeCode === settings.SETTING_TYPES.GDN_COUNTRIES && item.idSettingCompanyParent === idSettingCompany
    }).sort((a,b) => {
      return a.order - b.order
    }).map((item) => {
      item.units = getters.settingsCompany.filter((elem) => {
        return elem.settingTypeCode ===  settings.SETTING_TYPES.GDN_UNITS && elem.idSettingCompanyParent === item.idSettingCompany
      }).sort((a, b) => {
        return a.order - b.order
      })
      return item;
    })
  },
  gdnContent: (state, getters) => (idSettingCompany) => {
    return getters.settingsCompany.filter((item) => {
      return (item.code === settings.SETTING_TYPES.GDN_SECTION_PARAGRAPHS || item.code === settings.SETTING_TYPES.GDN_SECTION_TABS ) && item.idSettingCompanyParent === idSettingCompany
    }).sort((a,b) => {
      return a.order - b.order
    }).map((item) => {
      item.sections = getters.settingsCompany.filter((elem) => {
        return elem.settingTypeCode === settings.SETTING_TYPES.GDN_SUB_SECTIONS && elem.idSettingCompanyParent === item.idSettingCompany
      }).sort((a, b) => {
        return a.order - b.order
      })
      return item;
    })
  }
}